import { useState } from 'react';
import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

export function AdminBypass() {
  const [isVisible, setIsVisible] = useState(false);

  const disablePasswordGate = () => {
    localStorage.setItem('marketbloom_access', 'granted');
    window.location.reload();
  };

  const enablePasswordGate = () => {
    localStorage.removeItem('marketbloom_access');
    window.location.reload();
  };

  // Only show in development or if accessed via special key combo
  if (!import.meta.env.DEV && !isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50">
      {!isVisible ? (
        <Button
          onClick={() => setIsVisible(true)}
          variant="outline"
          size="sm"
          className="opacity-50 hover:opacity-100"
        >
          Admin
        </Button>
      ) : (
        <Card className="w-64">
          <CardHeader className="pb-2">
            <CardTitle className="text-sm">Password Gate Control</CardTitle>
          </CardHeader>
          <CardContent className="space-y-2">
            <Button
              onClick={disablePasswordGate}
              size="sm"
              className="w-full"
              variant="outline"
            >
              Disable Password Gate
            </Button>
            <Button
              onClick={enablePasswordGate}
              size="sm"
              className="w-full"
              variant="destructive"
            >
              Enable Password Gate
            </Button>
            <Button
              onClick={() => setIsVisible(false)}
              size="sm"
              className="w-full"
              variant="ghost"
            >
              Close
            </Button>
          </CardContent>
        </Card>
      )}
    </div>
  );
} 